<template>
  <div>
    <div class="nav">
      <div class="nav-center">
        <div class="box">
          <div class="logo" @click="goHome">
            <img src="@/assets/img/logo.png" alt />
          </div>
          <ul>
            <li v-for="(item, i) in navList" :key="i" :class="i == isActive ? 'actives' : ''" @click="route(item, i)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="box">
          <el-input v-model.trim="search" placeholder="搜索" @keyup.enter.native="searchBtn">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchBtn" style="cursor:pointer"></i>
          </el-input>
          <div class="login_box">
            <div style="display: inline-block;" v-if="!isLogin || name == '登录 / 注册'">
              <div class="my">
                <img src="@/assets/img/my.png" alt />
              </div>
              <span @click="login" style="cursor: pointer;">登录 / 注册</span>
            </div>
            <div style="display: inline-block;position: relative;" v-else>
              <div class="my" v-if="avatar">
                <img :src="avatar" alt />
              </div>
              <span style="cursor: pointer;" @click="$router.push('/my_collect')">
                {{ name }}
                <!-- <img
                  src="@/assets/img/icon1.png"
                  style="cursor: pointer; margin-left: 4px;"
                  @click.stop="showMenu"
                  alt
                /> -->
              </span>
              <!-- <div class="drop-down-menu" v-if="show">
                <ul>
                  <li v-for="(item, i) in list" :key="i" @click="jump(item)">
                    {{ item.title }}
                  </li>
                </ul>
              </div> -->
            </div>
            <div class="my order" @click="subscribe">
              <img src="@/assets/img/order.png" alt />
            </div>
            <span @click="subscribe" style="cursor: pointer;">订阅</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="loginDialog">
      <!-- 登录 -->
      <el-dialog :visible.sync="loginDialog" width="420px" :before-close="loginClose" :close-on-click-modal="false">
        <div class="dialogBox" v-if="isFlag">
          <p>账号密码登录</p>
          <div class="phone">
            <el-input placeholder="输入手机号" v-model="signLogin.phone"></el-input>
            <!-- <span>
              <img src="@/assets/img/icon2.png" alt />
            </span>-->
          </div>
          <el-input type="password" placeholder="密码" v-model="signLogin.passWord"></el-input>

          <div class="forget" @click="forgetPwd">忘记密码？</div>
          <el-button style="background: #0091ff;color:#fff" @click="signIn">登录</el-button>
          <div style="margin: 10px 0">or</div>
          <el-button @click="changeLogin">手机号快捷登录</el-button>
          <div class="agree">
            <div>
              点击
              <span style="margin-left: -4px;">登录</span>即表示已同意
            </div>
            <div @click="userAgreement">《第一财经》杂志网注册用户协议</div>
            <div @click="privacy">《隐私条款》</div>
          </div>
        </div>
        <div class="dialogBox" v-if="!isFlag">
          <p>手机号快捷登录</p>
          <el-input placeholder="输入手机号" v-model="fastLogin.phone"></el-input>
          <div class="code">
            <el-input placeholder="验证码" v-model="fastLogin.code"></el-input>
            <span @click="getCode" v-if="showBtnCode">获取验证码</span>
            <span v-else>{{ code_ts }}</span>
          </div>
          <Verify ref="verify" />

          <div style="color:#999999;margin-bottom: 14px;">
            未注册手机验证后自动注册
          </div>
          <el-button style="background: #0091ff;color:#fff" @click="fastLogIn">登录</el-button>
          <div style="margin: 10px 0">or</div>
          <el-button @click="changeLogin">账号密码登录</el-button>
          <div class="agree">
            <div>
              点击
              <span style="margin-left: -4px;">登录</span>即表示已同意
            </div>
            <div @click="userAgreement">《第一财经》杂志网注册用户协议</div>
            <div @click="privacy">《隐私条款》</div>
          </div>
        </div>
      </el-dialog>
      <!-- 用户协议 -->
      <el-dialog :visible.sync="agreeDialog" width="800px" :before-close="agreeClose" :close-on-click-modal="false"
        class="agreeDialog">
        <div class="agreeList">
          <h3>第一财经杂志网注册用户协议</h3>
          <ul>
            <li v-for="(item, i) in agreementList" :key="i">
              {{ item.content }}
            </li>
          </ul>
        </div>
      </el-dialog>
      <!-- 修改昵称 -->
      <el-dialog :visible.sync="editNameDialog" width="420px" :before-close="editNameClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="agreeList editName">
          <h3>修改昵称</h3>
          <el-input placeholder="输入昵称" v-model="editName" maxlength="16"></el-input>
          <el-button @click="editNameBtn">提交</el-button>
        </div>
      </el-dialog>
      <!-- 激活订阅码 -->
      <el-dialog :visible.sync="activationDialog" width="420px" :before-close="activationClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="agreeList editName">
          <h3>激活订阅码</h3>
          <el-input placeholder="输入订阅码" v-model="activation"></el-input>
          <el-button @click="activationBtn()">提交</el-button>
        </div>
      </el-dialog>
      <!-- 意见反馈 -->
      <el-dialog :visible.sync="feedBackDialog" width="420px" :before-close="feedBackClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>意见反馈</h3>
          <el-input placeholder="您的问题或建议" type="textarea" :rows="10" v-model="feedList.content" maxlength="500"
            show-word-limit></el-input>
          <div class="box">
            <el-input placeholder="邮箱" v-model="feedList.email"></el-input>
            <el-input placeholder="手机号（选填）" v-model="feedList.contact"></el-input>
            <el-button @click="feedBackBtn">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog :visible.sync="passWordDialog" width="420px" :before-close="passWordClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>修改密码</h3>
          <div class="box">
            <el-form :model="passWordForm" :rules="rules" ref="passWordForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input placeholder="手机号" v-model="passWordForm.phone" disabled></el-input>
                <span @click="sendCode" v-if="showSendCode">发送验证码</span>
                <span v-else>{{ sendCode_ts }}</span>
              </el-form-item>

              <el-form-item prop="code">
                <el-input placeholder="验证码" v-model="passWordForm.code"></el-input>
              </el-form-item>
              <Verify4 ref="verify4" />
              <el-form-item prop="passWord">
                <el-input type="password" placeholder="密码为6~16位数字、英文、符号，至少两种组合的字符"
                  v-model="passWordForm.passWord"></el-input>
              </el-form-item>
              <el-form-item prop="again">
                <el-input type="password" placeholder="再次输入密码" v-model="passWordForm.again"></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="editPwd('passWordForm')">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 忘记密码 -->
      <el-dialog :visible.sync="resetPwdDialog" width="420px" :before-close="resetPwdClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>忘记密码</h3>
          <div class="box">
            <el-form :model="resetPwdForm" :rules="rule" ref="resetPwdForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input placeholder="手机号" v-model="resetPwdForm.phone"></el-input>
                <span @click="resetSendCode" style="cursor: pointer;" v-if="showForgetBtn">发送验证码</span>
                <span v-else>{{ forgetCode_ts }}</span>
              </el-form-item>
              <Verify2 ref="verify2" />
              <el-form-item prop="code">
                <el-input placeholder="验证码" v-model="resetPwdForm.code"></el-input>
              </el-form-item>

              <el-form-item prop="passWord">
                <el-input type="password" placeholder="密码为6~16位数字、英文、符号，至少两种组合的字符"
                  v-model="resetPwdForm.passWord"></el-input>
              </el-form-item>
              <el-form-item prop="again">
                <el-input type="password" placeholder="再次输入密码" v-model="resetPwdForm.again"></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="resetPwd('resetPwdForm')">重置</el-button>

            <p>
              又想起来了，
              <span @click="goLogin">去登录</span>
            </p>
          </div>
        </div>
      </el-dialog>
      <!-- 修改手机号 -->
      <el-dialog :visible.sync="editPhoneDialog" width="420px" :before-close="editPhoneClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>更换手机号</h3>
          <div class="box">
            <el-form :model="editPhoneForm" :rules="editPhoneRule" ref="editPhoneForm" label-width="100px"
              class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input placeholder="请输入新手机号" v-model="editPhoneForm.phone"></el-input>
                <span @click="editPhoneSendCode" style="cursor: pointer;" v-if="showEditPhoneBtn">发送验证码</span>
                <span v-else>{{ phoneCode_ts }}</span>
              </el-form-item>
              <Verify3 ref="verify3" />
              <el-form-item prop="code">
                <el-input placeholder="验证码" v-model="editPhoneForm.code"></el-input>
              </el-form-item>

              <el-form-item prop="passWord">
                <el-input type="password" placeholder="当前密码" v-model="editPhoneForm.passWord"></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="editPhoneSubmit('editPhoneForm')">提交</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getlogin, getResetPhone, getResetPhoneCode } from "@/api/public";
import { getEditName } from "@/api/home";
import {
  getFeedBack,
  getSubscriptionCode,
  getEditPwd,
  getForgetCode,
  getFastCode,
  getFastLogin
} from "@/api/system";
import { userInformation } from "@/utils/userInfo";
import router from "../router";
import { getaddress } from "@/api/adv";
import { v4 as uuidv4 } from "uuid";
import province from "@/assets/json/province.json";
import VueBus from "@/utils/VueBus.js";
import Verify from "./verify.vue";
import Verify2 from "./verify2.vue";
import Verify3 from "./verify3.vue";
import Verify4 from "./verify4.vue";

export default {
  props: {
    showData: {}
  },
  inject: ["reload"],
  data() {
    return {
      userInfo: {}, //用户信息
      navList: [
        {
          name: "首页",
          path: "home"
        },
        {
          name: "阅读",
          path: "read"
        },
        {
          name: "音频",
          path: "radio"
        },
        {
          name: "新皮层",
          path: "/new_home"
        }
      ],
      isActive: 0,
      search: "",
      // 弹框
      loginDialog: false, // 登录弹框
      agreeDialog: false, // 用户协议弹框
      editNameDialog: false, //修改昵称
      editName: "",
      activationDialog: false, //激活订阅码
      activation: "",
      feedBackDialog: false, //意见反馈
      feedList: {
        content: "",
        email: "", //邮箱
        contact: ""
      },
      resetPwdDialog: false, //重置密码
      resetPwdForm: {
        phone: "",
        code: "",
        passWord: "",
        again: ""
      },
      uId: "",
      rule: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号码"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符",
            trigger: "blur"
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){6,16}$/,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符"
          }
        ],
        again: [{ required: true, message: "再次输入密码", trigger: "blur" }]
      },
      passWordDialog: false, //修改密码
      passWordForm: {
        phone: "",
        code: "",
        passWord: "",
        again: ""
      },
      id: "",
      rules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符",
            trigger: "blur"
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){6,16}$/,
            // ^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){6,16}$
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符"
          }
        ],
        again: [{ required: true, message: "再次输入密码", trigger: "blur" }]
      },
      isFlag: true, //登录方式，ture：账号密码
      // 账号密码登录
      signLogin: {
        phone: "",
        passWord: ""
      },
      // 快速登录
      fastLogin: {
        phone: "",
        code: ""
      },
      agreementList: [
        {
          content:
            "1. 第一财经网向注册用户提供用户评论留言、社区发帖跟帖等服务。未实名注册的用户仅可浏览第一财经网内容，不可使用上述服务。"
        },
        {
          content: "2. 用户注册时须提交中国境内手机号。"
        },
        {
          content:
            "3. 注册用户可自主选择昵称、上传头像,昵称和头像经审核通过后显示在前端。"
        },
        {
          content: "4. 注册用户可修改昵称和头像,每30天可修改一次。"
        },
        {
          content: "5. 注册用户发布的内容经审核通过后显示。"
        },
        {
          content:
            "6. 注册用户发布在第一财经网的内容,其知识产权属于发布有关内容的用户,第一财经网有权记录、保存、展示有关内容。"
        },
        {
          content:
            "7. 第一财经网严格保护用户个人隐私,除法律规定的情况之外,不向第三方透露用户注册账号及使用账号过程中产生的个人信息。"
        },
        {
          content:
            "8. 注册用户在第一财经网/APP上的一切活动、发布的一切内容,均须遵守中国法律和互联网信息管理规定。对于违反法律和规定的用户,将采取冻结账号、移交司法等措施。"
        },
        {
          content: "9. 用户注册第一财经网账号,视为同意以上协议。"
        }
      ],
      isLogin: false, //是否登陆
      avatar: require("@/assets/img/my.png"), //登陆成功后用户头像
      name: "登录 / 注册", //用户名,
      userId: "",
      show: false,
      list: [
        { title: "我的收藏", name: "my_collect" },
        { title: "我的关注", name: "my_concerns" },
        { title: "我的投票", name: "my_vote" },
        { title: "修改昵称", name: "edit_name" },
        { title: "修改密码", name: "edit_passWord" },
        { title: "修改手机号", name: "edit_phone" },
        { title: "购买记录", name: "single_copy" },
        { title: "使用帮助", name: "help" },
        { title: "意见反馈", name: "feedBack" },
        { title: "激活订阅码", name: "activation" },
        { title: "退出" }
      ],
      // 修改手机号
      editPhoneDialog: false,
      editPhoneForm: {
        phone: "",
        code: "",
        passWord: ""
      },
      editPhoneRule: {
        phone: [
          { required: true, message: "请输入新手机号", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      },
      showEditPhoneBtn: true,
      phoneCode_ts: "获取验证码",
      phoneSec: 60,
      //登录  获取验证码倒计时
      showBtnCode: true,
      code_ts: "获取验证码",
      sec: 60,
      //修改密码
      showSendCode: true,
      sendCode_ts: "发送验证码",
      sendSec: 60,
      isSend: false,
      // 忘记密码
      showForgetBtn: true,
      forgetCode_ts: "发送验证码",
      forgetSec: 60,
      outLogin: 0,
      routerList: [
        "my_collect",
        "my_concerns",
        "my_vote",
        "my_vote_detail",
        "single_copy",
        "help"
      ],
      path: "",
      notLogin: false
    };
  },
  watch: {
    showData(newVal) {
      this.show = newVal;
    },
    $route(newRoute, oldRoute) {
      this.path = newRoute.name;
      this.notLogin = newRoute.params.notLogin;
      if (this.notLogin) {
        this.login();
      }
      if (localStorage.getItem("isLogin") == null) {
        if (this.outLogin == 0 && this.routerList.indexOf(this.path) !== -1) {
          this.login();
          this.resetSetItem("isActive", 0);
          this.$router.push({
            name: "home",
            params: {
              notLogin: true
            }
          });
        }
      }
      if (newRoute.path == oldRoute.push) {
        this.resetSetItem("isActive", 0);
      } else {
        this.isActive = localStorage.getItem("isActive");
      }
    }
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });

      this.resetSetItem("isActive", 1);
    },
    login() {
      this.loginDialog = true;
      this.signLogin = {
        phone: "",
        passWord: ""
      };
      this.fastLogin = {
        phone: "",
        code: ""
      };
    },
    // 用户密码登录
    signIn() {
      if (this.signLogin.phone == "" || this.signLogin.passWord == "") {
        this.$message.error("用户名或密码不能为空！");
      } else {
        if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.signLogin.phone)) {
          this.$message.error("手机号输入错误，请输入正确的手机号");
        } else {
          var params = {
            login_name: this.signLogin.phone,
            pwd: this.signLogin.passWord,
            mobile: "pc",
            device: {
              name: "pc", //固定传字符串PC
              token: "pc", //固定传字符串PC
              type: "pc" //固定传字符串PC
            }
          };
          getlogin(params).then(res => {
            if (res.status == 201 || res.status == 200) {
              var token = res.data.data.token;
              this.loginDialog = false;
              this.isLogin = true;
              this.avatar = res.data.data.avatar;
              this.name = res.data.data.nickname;
              this.userId = res.data.data.id;
              this.resetSetItem("isLogin", true);
              this.resetSetItem("Authorization", token);
              this.resetSetItem("userInfo", JSON.stringify(res.data.data));
              this.signLogin.phone = "";
              this.signLogin.passWord = "";

              if (res.data.data.warning_message != null) {
                this.$message.success(res.data.data.warning_message);
              } else {
                this.$message.success("登录成功");
              }
              this.reload();
            }
          });
        }
      }
    },
    userAgreement() {
      this.loginDialog = false;
      this.agreeDialog = true;
    },
    // 意见反馈
    feedBackBtn() {
      if (this.feedList.content == "" || this.feedList.email == "") {
        this.$message.error("反馈内容或邮箱不能为空");
      } else {
        if (this.feedList.contact != "") {
          if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.feedList.contact)) {
            this.$message.error("手机号输入错误，请输入正确的手机号");
          }
        }
        if (this.feedList.email == "") {
          this.$message.error("请填写邮箱后再次提交");
        } else {
          if (
            !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
              this.feedList.email
            )
          ) {
            this.$message.error("邮箱输入错误，请输入正确的邮箱");
          } else {
            getFeedBack(this.feedList).then(res => {
              if (res.status == 201 || res.status == 200) {
                this.$message.success("意见反馈成功!");
                this.feedBackDialog = false;
              }
            });
          }
        }
      }
    },
    // 关闭登录弹框
    loginClose() {
      this.loginDialog = false;
    },
    agreeClose() {
      this.agreeDialog = false;
    },
    feedBackClose() {
      this.feedBackDialog = false;
    },
    // 修改密码关闭弹框
    passWordClose() {
      this.passWordDialog = false;
    },
    // 重置密码关闭弹框
    resetPwdClose() {
      this.resetPwdDialog = false;
      this.isSend = false;
    },
    resetSendCode() {
      if (this.resetPwdForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {


        this.$refs.verify2.showCaptcha().then(res => {
          var params = {
            login_name: this.resetPwdForm.phone,
            type: "0"
          };
          getForgetCode(params).then(res => {
            if (res.data.data.returncode === "0000") {
              this.$message.success(res.data.data.returnmsg);
              this.isSend = true;
              this.uId = res.data.data.id;
              var timer = setInterval(() => {
                this.forgetSec = this.forgetSec - 1;
                this.forgetCode_ts = this.forgetSec + "S后重试";
                this.showForgetBtn = false;
                if (this.forgetSec === 0) {
                  clearInterval(timer);
                  this.forgetSec = 60;
                  this.forgetCode_ts = this.forgetSec + "S后重试";
                  this.showForgetBtn = true;
                }
              }, 1000);
            } else {
              this.$message.error(res.data.data.returnmsg);
            }
          });
        });
        // .catch(error => {
        //   this.$message.error("发送失败");
        // });
      }
    },
    // 忘记密码
    forgetPwd() {
      this.loginDialog = false;
      this.resetPwdDialog = true;
      this.$nextTick(() => {
        this.$refs.resetPwdForm.resetFields();
      });
    },
    // 修改手机号
    editPhoneClose() {
      //关闭按钮
      this.editPhoneDialog = false;
    },
    editPhoneSendCode() {
      //获取验证码
      if (this.editPhoneForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        var userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.$refs.verify3.showCaptcha().then(res => {
          var params = {
            yicai_user_id: userInfo.yicai_user_id, //登录账号
            login_name: this.editPhoneForm.phone,
            type: 0
          };
          getResetPhoneCode(params).then(res => {
            this.$message.success("发送成功，请注意查看手机");
            var timer = setInterval(() => {
              this.phoneSec = this.phoneSec - 1;
              this.phoneCode_ts = this.phoneSec + "S后重试";
              this.showEditPhoneBtn = false;
              if (this.phoneSec === 0) {
                clearInterval(timer);
                this.phoneSec = 60;
                this.phoneCode_ts = this.phoneSec + "S后重试";
                this.showEditPhoneBtn = true;
              }
            }, 1000);
          });
        })
      }
    },
    editPhoneSubmit(editPhoneForm) {
      this.$refs[editPhoneForm].validate(valid => {
        if (valid) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          var params = {
            yicai_user_id: String(userInfo.yicai_user_id), //登录账号
            login_name: this.editPhoneForm.phone, //手机号
            type: "0", //注册类型0:手机，1：邮箱
            pwd: this.editPhoneForm.passWord, //密码
            code: this.editPhoneForm.code, //验证码
            token: localStorage.getItem("Authorization")
          };
          // return;
          getResetPhone(params).then(res => {
            this.editPhoneDialog = false;
            if (
              res.data.data.returncode == "1001" ||
              res.data.data.returncode == "1053"
            ) {
              this.$message.error(res.data.data.returnmsg);
            } else {
              this.$message.success("修改成功");
              this.resetSetItem("userInfo", JSON.stringify(res.data.data));
              this.reload();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 关闭修改昵称
    editNameClose() {
      this.editNameDialog = false;
    },
    // 修改昵称接口
    editNameBtn() {
      if (this.editName == "") {
        this.$message.error("请输入昵称");
      } else {
        var userInfo = {};
        userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.nickname = this.editName;
        var params = {
          avatar: userInfo.avatar,
          id: userInfo.id,
          is_vip: userInfo.has_read_ability,
          login_name: userInfo.login_name,
          nickname: this.editName,
          token: userInfo.token,
          read_ability_expired_at: userInfo.read_ability_expired_at
        };
        getEditName(params).then(res => {
          if (res.status == 201 || res.status == 200) {
            this.resetSetItem("userInfo", JSON.stringify(userInfo));
            this.editNameDialog = false;
            this.reload();
          }
        });
      }
    },
    // 激活订阅码
    activationClose() {
      this.activationDialog = false;
    },
    activationBtn() {
      if (this.activation == "") {
        this.$message.error("请输入订阅码");
      } else {
        getSubscriptionCode(this.activation)
          .then(res => {
            if (res.status == 201 || res.status == 200) {
              this.$message.success("成功激活订阅码");
              this.activationDialog = false;
            }
          })
          .catch(error => {
            this.$message.error("订阅码错误");
            this.activation = "";
          });
      }
    },
    // 切换登录方式
    changeLogin() {
      this.isFlag = !this.isFlag;
    },
    // 快速登录
    fastLogIn() {
      if (this.fastLogin.phone == "" || this.fastLogin.code == "") {
        this.$message.error("手机号或者验证码不能为空");
      } else {
        var params = {
          code: this.fastLogin.code,
          login_name: this.fastLogin.phone,
          mobile: "pc",
          device: {
            name: "pc", //固定传字符串PC
            type: "pc", //固定传字符串PC
            token: "pc", //固定传字符串PC
          }
        };
        getFastLogin(params).then(res => {
          var token = res.data.data.token;
          this.loginDialog = false;
          this.isLogin = true;
          this.avatar = res.data.data.avatar;
          this.name = res.data.data.nickname;
          this.userId = res.data.data.id;
          this.resetSetItem("isLogin", true);
          this.resetSetItem("Authorization", token);
          this.resetSetItem("userInfo", JSON.stringify(res.data.data));
          if (res.data.data.warning_message != null) {
            this.$message.success(res.data.data.warning_message);
          } else {
            this.$message.success("登录成功");
          }
          this.reload();
        });
        // .catch(error => {
        //   this.$message.error("手机号或验证码错误");
        // });
      }
    },
    // 获取验证码
    getCode() {
      if (this.fastLogin.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        this.$refs.verify.showCaptcha().then(res => {
          var params = {
            login_name: this.fastLogin.phone,
            type: "0",
            ...res
          };
          getFastCode(params)
            .then(res => {
              if (res.data.data.returncode === "0000") {
                this.$message.success(res.data.data.returnmsg);
                var timer = setInterval(() => {
                  this.sec = this.sec - 1;
                  this.code_ts = this.sec + "S后重试";
                  this.showBtnCode = false;
                  if (this.sec === 0) {
                    clearInterval(timer);
                    this.sec = 60;
                    this.code_ts = this.sec + "S后重试";
                    this.showBtnCode = true;
                    this.$refs.verify.destroy();
                  }
                }, 1000);
              } else {
                this.$message.error(res.data.data.returnmsg);
              }
            })
            .catch(error => {
              this.$message.error("发送失败");
            });
        });
      }
    },
    // 头部跳转
    route(name, i) {
      this.isActive = i;
      this.resetSetItem("isActive", this.isActive);
      if (name.path == "home") {
        this.$router.push({ path: "/" });
      } else if (name.path == "read") {
        this.$router.push({ path: "/read" });
      } else if (name.path == "radio") {
        this.$router.push({ path: "/radio" });
      } else {
        this.$router.push({ path: name.path });
      }
    },
    // 显示隐藏下拉菜单
    showMenu() {
      this.show = !this.show;
      this.$emit("func", this.show);
    },
    // 去登录
    goLogin() {
      if (localStorage.getItem("Authorization") == null) {
        this.resetPwdDialog = false;
        this.loginDialog = true;
        this.isSend = false;
      } else {
        this.$message.error("您已登录，请先退出登录再进行登录！");
      }
    },
    // 发送验证码
    sendCode() {
      if (this.passWordForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        this.$refs.verify4.showCaptcha().then(res => {
          var params = {
            login_name: this.passWordForm.phone,
            type: "0"
          };
          getForgetCode(params)
            .then(res => {
              this.$message.success("发送成功，请注意查看手机");
              this.id = res.data.data.id;
              var timer = setInterval(() => {
                this.sendSec = this.sendSec - 1;
                this.sendCode_ts = this.sendSec + "S后重试";
                this.showSendCode = false;
                if (this.sendSec === 0) {
                  clearInterval(timer);
                  this.sendSec = 60;
                  this.sendCode_ts = this.sendSec + "S后重试";
                  this.showSendCode = true;
                }
              }, 1000);
            })
            .catch(error => {
              this.$message.error("发送失败");
            });
        })
      }
    },
    // 修改密码
    editPwd(passWordForm) {
      this.$refs[passWordForm].validate(valid => {
        if (valid) {
          if (this.passWordForm.passWord == this.passWordForm.again) {
            var params = {
              id: this.id,
              login_name: this.passWordForm.phone,
              pwd: this.passWordForm.passWord,
              code: this.passWordForm.code
            };
            getEditPwd(params).then(res => {
              this.passWordDialog = false;
              this.$message.success(res.data.data.returnmsg);
            });
          } else {
            this.$message.error("两次密码输入不一致");
          }
        } else {
          return false;
        }
      });
    },
    // 忘记密码
    resetPwd(resetPwdForm) {
      if (this.isSend) {
        this.$refs[resetPwdForm].validate(valid => {
          if (valid) {
            if (this.resetPwdForm.passWord == this.resetPwdForm.again) {
              var params = {
                id: this.uId,
                login_name: this.resetPwdForm.phone,
                pwd: this.resetPwdForm.passWord,
                code: this.resetPwdForm.code
              };
              getEditPwd(params).then(res => {
                this.resetPwdDialog = false;
                this.$message.success(res.data.data.returnmsg);
              });
            } else {
              this.$message.error("两次密码输入不一致");
            }
          } else {
            return false;
          }
        });
      } else {
        this.$message.error("请先获取验证码");
      }
    },
    // 隐私协议
    privacy() {
      this.loginDialog = false;
      this.$router.push({ path: "/privacy" });
    },
    jump(scope) {
      if (scope.name == "edit_name") {
        this.editNameDialog = true;
        this.editName = "";
      } else if (scope.name == "activation") {
        this.activationDialog = true;
        this.activation = "";
      } else if (scope.name == "edit_phone") {
        this.editPhoneDialog = true;
        this.editPhoneForm.phone = "";
        this.editPhoneForm.code = "";
        this.editPhoneForm.passWord = "";
      } else if (scope.name == "feedBack") {
        this.feedBackDialog = true;
        this.feedList.content = "";
        this.feedList.email = "";
        this.feedList.contact = "";
      } else if (scope.name == "edit_passWord") {
        this.passWordDialog = true;
        this.passWordForm.phone = this.userInfo.login_name;
        this.passWordForm.code = "";
        this.passWordForm.passWord = "";
        this.passWordForm.again = "";
      } else if (scope.title == "退出") {
        this.resetSetItem("isLogin", false);
        localStorage.removeItem("Authorization");
        localStorage.removeItem("userInfo");
        this.$message.success("退出登录");
        this.isLogin = false;
        this.$router.push({ path: "/" });
        this.resetSetItem("isActive", 0);
      } else {
        this.$router.push({
          name: scope.name,
          params: { title: scope.title, id: this.userId }
        });

        this.resetSetItem("isActive", 0);
      }
    },
    // 搜索按钮
    searchBtn() {
      if (this.search != "") {
        var keyword = this.search;
        this.search = "";
        var flag = false;
        if (this.$router.app._route.name == "search") {
          flag = true;
        }
        this.$router.push({
          name: "search",
          params: { keyword: keyword }
        });
        if (flag) {
          location.reload();
        }
      }
    },
    // 订阅
    subscribe() {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        path: "/member"
      });
    }
  },
  created() {
    VueBus.$on("openActivationDialog", () => {
      this.activationDialog = true;
    });
    if (localStorage.getItem("Authorization") != null) {
      this.isLogin = true;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.name = this.userInfo.nickname;
      this.avatar = this.userInfo.avatar;
      this.userId = this.userInfo.id;
    }
    // 监听sessionStorage
    window.addEventListener("setItem", () => {
      if (localStorage.getItem("isLogin") == null) {
        this.isLogin = false;
        localStorage.removeItem("isLogin");
      }
      if (localStorage.getItem("isLogin") == "false") {
        this.isLogin = localStorage.getItem("isLogin");
        localStorage.removeItem("isLogin");
      } else {
        this.isLogin = localStorage.getItem("isLogin");
      }
      if (localStorage.getItem("Authorization") != null) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (this.userInfo) {
          this.userId = this.userInfo.id;
          this.name = this.userInfo.nickname;
          this.avatar = this.userInfo.avatar;
        }
      }
    });
  },
  mounted() {
    // if (
    //   localStorage.getItem("address_code") == null ||
    //   localStorage.getItem("address_code") == "undefined"
    // ) {
    //   // 接口报错，暂时取消调用
    //   getaddress().then(res => {
    //     try {
    //       var _this = this;
    //       var address_code;
    //       var address = res.data;
    //       province.provinces.forEach((element, index) => {
    //         if (address.indexOf(element.name) > 0) {
    //           element.cities.forEach((element2, index) => {
    //             if (address.indexOf(element2.name) > 0) {
    //               address_code = element2.code;
    //             }
    //           });
    //         }
    //       });
    //       if (address_code) {
    //         _this.resetSetItem("address_code", address_code);
    //       } else {
    //         localStorage.removeItem("address_code");
    //       }
    //     } catch (error) {}
    //   });
    // }

    if (localStorage.getItem("uuidv4") == null) {
      this.resetSetItem("uuidv4", uuidv4());
    }
    if (localStorage.getItem("isActive")) {
      this.isActive = localStorage.getItem("isActive");
    } else {
      this.isActive = 0;
      this.resetSetItem("isActive", 0);
    }
  },
  components: {
    Verify,
    Verify2,
    Verify3,
    Verify4
  }
};
</script>
<style lang="scss" scoped>
.nav {
  background: #ffffff;
  white-space: nowrap;
  font-size: 16px;
  position: fixed;
  width: 100%;
  z-index: 10;
  top: 0;

  .nav-center {
    // width: 79%;
    width: 1200px;
    line-height: 70px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .logo {
      width: 130px;
      margin-right: 26px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }

    ul {
      display: flex;

      li {
        padding: 0 5px;
        margin-left: 50px;
        color: #333333;
        cursor: pointer;
      }

      .actives {
        color: #0091ff;
        border-bottom: 4px solid;
      }
    }

    .el-input {
      width: 254px;

      >>>.el-input__inner {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 0 !important;
        font-size: 12px;
      }

      >>>.el-input__suffix {
        top: 1px;
      }
    }

    .login_box {
      .my {
        width: 26px;
        height: 26px;
        display: inline-block;
        margin-left: 30px;
        margin-right: 4px;

        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }

      .order {
        cursor: pointer;
        width: 20px;
      }

      .drop-down-menu {
        position: absolute;
        z-index: 3;
        background: #fff;
        width: 150px;
        text-align: center;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);

        ul {
          display: flex;
          flex-direction: column;
          line-height: initial;

          li {
            margin-left: 0;
            line-height: 50px;
            border-bottom: 1px solid #eeeeee;
          }

          li:hover {
            background: #0091ff;
            color: #fff;
            border-bottom: none;
          }
        }
      }
    }
  }
}

// 弹框
>>>.el-dialog__body {
  padding: 0px 40px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  text-align: center;
  margin-top: 5px;
}

.dialogBox {
  color: #333333;

  p {
    line-height: 24px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 40px;
  }

  .el-input {
    height: 50px;
  }

  .el-button {
    border-radius: 23px;
    color: #333333;
    font-size: 16px;
    width: 300px;
    padding: 14px 20px;
    border: 1px solid #dcdfe6;
  }

  .el-button:hover {
    background: #ffffff;
    border-color: #dcdfe6;
    color: #606266;
  }

  .forget {
    text-align: right;
    margin-bottom: 20px;
    cursor: pointer;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #e6e6e6;
    border-radius: 0;
    height: 34px;
    padding-left: 0;
  }

  .phone {
    position: relative;
    height: 60px;

    span {
      position: absolute;
      right: 0;
      top: 4px;
    }
  }

  .code {
    position: relative;
    margin-top: 10px;

    span {
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
    }
  }

  .agree {
    margin-top: 10px;
    padding-bottom: 30px;
    cursor: pointer;

    div {
      line-height: 28px;
      color: #0091ff;
    }

    div:first-child {
      color: #b6b6b6;
    }
  }
}

.agreeDialog {
  >>>.el-dialog__body {
    padding: 0px 5%;
    margin-top: 5px;
  }
}

.agreeList {
  color: #333333;

  h3 {
    font-size: 30px;
    line-height: 36px;
  }

  ul {
    text-align: left;
    margin-top: 20px;
    padding-bottom: 40px;

    li {
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
    }
  }
}

.editName {
  padding: 0 30px;

  .el-input {
    margin: 30px 0 30px;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0px;
    padding: 0;
  }

  .el-button {
    width: 100%;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin-bottom: 30px;
    font-size: 16px;
  }
}

.feedBackList {

  // padding: 0 20px;
  h3 {
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 10px;
  }

  .el-textarea {
    margin-top: 20px;
  }

  >>>.el-textarea__inner {
    border: 1px dashed #dcdfe6;
    border-radius: 0;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0px;
    padding: 0;
  }

  .box {
    padding: 20px;

    >>>.el-form-item {
      margin-bottom: 4px;
      position: relative;

      span {
        position: absolute;
        right: 0;
        bottom: 17px;
        font-size: 14px;
      }
    }

    >>>.el-form-item__content {
      margin-left: 0 !important;

      .el-form-item__error {
        top: 80%;
      }
    }
  }

  .el-input {
    margin-bottom: 15px;
  }

  .el-button {
    width: 300px;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin: 20px 0 10px 0;
    font-size: 16px;
  }

  p {
    margin-bottom: 20px;

    span {
      color: #0091ff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hearder.vue